var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCertificate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M399.072 299.247c-28.896 0-52.403 23.508-52.403 52.403s23.508 52.403 52.403 52.403 52.403-23.508 52.403-52.403-23.508-52.403-52.403-52.403zM399.072 434.053a81.884 81.884 0 0 1-33.599-7.19v44.003l33.599-10.949 33.599 10.949v-44.003a81.887 81.887 0 0 1-33.599 7.19z",
    fill: "#81A63D",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 41.134v388.334h335.473V403.99c-11.743-14.243-18.804-32.482-18.804-52.34 0-45.437 36.966-82.403 82.403-82.403s82.403 36.966 82.403 82.403c0 19.858-7.062 38.097-18.804 52.34v25.478H512V41.134H0zm256 249.419H69.336v-30H256v30zm186.664-78.542H69.336v-30h373.328v30zm0-78.542H69.336v-30h373.328v30z",
    fill: "#81A63D",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificate);
export default __webpack_public_path__ + "static/media/certificate.0ae5f2af85df76bfb72feff7d1366fd8.svg";
export { ForwardRef as ReactComponent };